export default __webpack_public_path__ + "locales/bg/Webhooks.json?hash=18ffb3124e8cc7664f0bd467c51c1358";